import React from 'react';

import Tab from 'views/sms/Tab';

function BlastSms() {
    return <Tab />;
}

export default React.memo(BlastSms);
